//@ts-ignore
import hashFile from "browser-md5-file"

export async function createHashFile(file: File) {
	return new Promise<string>((resolve, reject) => {
		const hash = new hashFile()
		hash.md5(file, (err: unknown, md5: string) => {
			if (err) reject("Ошибка генерации hash")
			if (md5) {
				resolve(md5)
			} else reject("Ошибка генерации hash")
		})
	})
}
